/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Account API
 * This API is for managing Accounts, Organizations and Workspaces.
 * OpenAPI spec version: 1.4.2
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePartnershipDto,
  PartnershipsControllerCreate201,
  PartnershipsControllerCreate400,
  PartnershipsControllerFindAll200,
  PartnershipsControllerFindAllParams,
  PartnershipsControllerGet200,
  PartnershipsControllerGet404
} from '../../schemas';

import { customFetch } from '../../../../../clients/customInstance';
import type { ErrorType } from '../../../../../clients/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Create a partnership between a broker organization and an advertiser workspace
 * @summary Create a partnership
 */
export type partnershipsControllerCreateResponse201 = {
  data: PartnershipsControllerCreate201
  status: 201
}

export type partnershipsControllerCreateResponse400 = {
  data: PartnershipsControllerCreate400
  status: 400
}

export type partnershipsControllerCreateResponseSuccess = (partnershipsControllerCreateResponse201) & {
  headers: Headers;
};
export type partnershipsControllerCreateResponseError = (partnershipsControllerCreateResponse400) & {
  headers: Headers;
};

export type partnershipsControllerCreateResponse = (partnershipsControllerCreateResponseSuccess | partnershipsControllerCreateResponseError)

export const getPartnershipsControllerCreateUrl = (accountId: string,) => {


  

  return `/accounts/${accountId}/partnerships`
}

export const partnershipsControllerCreate = async (accountId: string,
    createPartnershipDto: CreatePartnershipDto, options?: RequestInit): Promise<partnershipsControllerCreateResponse> => {
  
  return customFetch<partnershipsControllerCreateResponse>(getPartnershipsControllerCreateUrl(accountId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPartnershipDto,)
  }
);}
  



export const getPartnershipsControllerCreateMutationOptions = <TError = ErrorType<PartnershipsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerCreate>>, TError,{accountId: string;data: CreatePartnershipDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerCreate>>, TError,{accountId: string;data: CreatePartnershipDto}, TContext> => {

const mutationKey = ['partnershipsControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnershipsControllerCreate>>, {accountId: string;data: CreatePartnershipDto}> = (props) => {
          const {accountId,data} = props ?? {};

          return  partnershipsControllerCreate(accountId,data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PartnershipsControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof partnershipsControllerCreate>>>
    export type PartnershipsControllerCreateMutationBody = CreatePartnershipDto
    export type PartnershipsControllerCreateMutationError = ErrorType<PartnershipsControllerCreate400>

    /**
 * @summary Create a partnership
 */
export const usePartnershipsControllerCreate = <TError = ErrorType<PartnershipsControllerCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerCreate>>, TError,{accountId: string;data: CreatePartnershipDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnershipsControllerCreate>>,
        TError,
        {accountId: string;data: CreatePartnershipDto},
        TContext
      > => {
      return useMutation(getPartnershipsControllerCreateMutationOptions(options), queryClient);
    }
    /**
 * List advertiser workspaces partnered with any organization of a broker account
 * @summary List broker account partnerships
 */
export type partnershipsControllerFindAllResponse200 = {
  data: PartnershipsControllerFindAll200
  status: 200
}

export type partnershipsControllerFindAllResponseSuccess = (partnershipsControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type partnershipsControllerFindAllResponse = (partnershipsControllerFindAllResponseSuccess)

export const getPartnershipsControllerFindAllUrl = (accountId: string,
    params?: PartnershipsControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/accounts/${accountId}/partnerships?${stringifiedParams}` : `/accounts/${accountId}/partnerships`
}

export const partnershipsControllerFindAll = async (accountId: string,
    params?: PartnershipsControllerFindAllParams, options?: RequestInit): Promise<partnershipsControllerFindAllResponse> => {
  
  return customFetch<partnershipsControllerFindAllResponse>(getPartnershipsControllerFindAllUrl(accountId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getPartnershipsControllerFindAllQueryKey = (accountId: string,
    params?: PartnershipsControllerFindAllParams,) => {
    return [
    `/accounts/${accountId}/partnerships`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getPartnershipsControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError = ErrorType<unknown>>(accountId: string,
    params?: PartnershipsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnershipsControllerFindAllQueryKey(accountId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnershipsControllerFindAll>>> = ({ signal }) => partnershipsControllerFindAll(accountId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PartnershipsControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof partnershipsControllerFindAll>>>
export type PartnershipsControllerFindAllQueryError = ErrorType<unknown>


export function usePartnershipsControllerFindAll<TData = Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params: undefined |  PartnershipsControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnershipsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof partnershipsControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnershipsControllerFindAll<TData = Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: PartnershipsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnershipsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof partnershipsControllerFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnershipsControllerFindAll<TData = Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: PartnershipsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List broker account partnerships
 */

export function usePartnershipsControllerFindAll<TData = Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError = ErrorType<unknown>>(
 accountId: string,
    params?: PartnershipsControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPartnershipsControllerFindAllQueryOptions(accountId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Delete a partnership between a broker organization and an advertiser workspace
 * @summary Delete a partnership
 */
export type partnershipsControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type partnershipsControllerDeleteResponseSuccess = (partnershipsControllerDeleteResponse204) & {
  headers: Headers;
};
;

export type partnershipsControllerDeleteResponse = (partnershipsControllerDeleteResponseSuccess)

export const getPartnershipsControllerDeleteUrl = (accountId: string,
    partnershipId: unknown,) => {


  

  return `/accounts/${accountId}/partnerships/${partnershipId}`
}

export const partnershipsControllerDelete = async (accountId: string,
    partnershipId: unknown, options?: RequestInit): Promise<partnershipsControllerDeleteResponse> => {
  
  return customFetch<partnershipsControllerDeleteResponse>(getPartnershipsControllerDeleteUrl(accountId,partnershipId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getPartnershipsControllerDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext> => {

const mutationKey = ['partnershipsControllerDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnershipsControllerDelete>>, {accountId: string;partnershipId: unknown}> = (props) => {
          const {accountId,partnershipId} = props ?? {};

          return  partnershipsControllerDelete(accountId,partnershipId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PartnershipsControllerDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof partnershipsControllerDelete>>>
    
    export type PartnershipsControllerDeleteMutationError = ErrorType<unknown>

    /**
 * @summary Delete a partnership
 */
export const usePartnershipsControllerDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnershipsControllerDelete>>,
        TError,
        {accountId: string;partnershipId: unknown},
        TContext
      > => {
      return useMutation(getPartnershipsControllerDeleteMutationOptions(options), queryClient);
    }
    /**
 * Get a partnership by id
 * @summary Get a partnership by id
 */
export type partnershipsControllerGetResponse200 = {
  data: PartnershipsControllerGet200
  status: 200
}

export type partnershipsControllerGetResponse404 = {
  data: PartnershipsControllerGet404
  status: 404
}

export type partnershipsControllerGetResponseSuccess = (partnershipsControllerGetResponse200) & {
  headers: Headers;
};
export type partnershipsControllerGetResponseError = (partnershipsControllerGetResponse404) & {
  headers: Headers;
};

export type partnershipsControllerGetResponse = (partnershipsControllerGetResponseSuccess | partnershipsControllerGetResponseError)

export const getPartnershipsControllerGetUrl = (accountId: string,
    partnershipId: unknown,) => {


  

  return `/accounts/${accountId}/partnerships/${partnershipId}`
}

export const partnershipsControllerGet = async (accountId: string,
    partnershipId: unknown, options?: RequestInit): Promise<partnershipsControllerGetResponse> => {
  
  return customFetch<partnershipsControllerGetResponse>(getPartnershipsControllerGetUrl(accountId,partnershipId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  




export const getPartnershipsControllerGetQueryKey = (accountId: string,
    partnershipId: unknown,) => {
    return [
    `/accounts/${accountId}/partnerships/${partnershipId}`
    ] as const;
    }

    
export const getPartnershipsControllerGetQueryOptions = <TData = Awaited<ReturnType<typeof partnershipsControllerGet>>, TError = ErrorType<PartnershipsControllerGet404>>(accountId: string,
    partnershipId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnershipsControllerGetQueryKey(accountId,partnershipId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnershipsControllerGet>>> = ({ signal }) => partnershipsControllerGet(accountId,partnershipId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(accountId && partnershipId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PartnershipsControllerGetQueryResult = NonNullable<Awaited<ReturnType<typeof partnershipsControllerGet>>>
export type PartnershipsControllerGetQueryError = ErrorType<PartnershipsControllerGet404>


export function usePartnershipsControllerGet<TData = Awaited<ReturnType<typeof partnershipsControllerGet>>, TError = ErrorType<PartnershipsControllerGet404>>(
 accountId: string,
    partnershipId: unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnershipsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof partnershipsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnershipsControllerGet<TData = Awaited<ReturnType<typeof partnershipsControllerGet>>, TError = ErrorType<PartnershipsControllerGet404>>(
 accountId: string,
    partnershipId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnershipsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof partnershipsControllerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePartnershipsControllerGet<TData = Awaited<ReturnType<typeof partnershipsControllerGet>>, TError = ErrorType<PartnershipsControllerGet404>>(
 accountId: string,
    partnershipId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a partnership by id
 */

export function usePartnershipsControllerGet<TData = Awaited<ReturnType<typeof partnershipsControllerGet>>, TError = ErrorType<PartnershipsControllerGet404>>(
 accountId: string,
    partnershipId: unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof partnershipsControllerGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPartnershipsControllerGetQueryOptions(accountId,partnershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * Permanently delete a partnership between a broker organization and an advertiser workspace
 * @summary Hard delete a partnership
 */
export type partnershipsControllerHardDeleteResponse204 = {
  data: void
  status: 204
}

export type partnershipsControllerHardDeleteResponseSuccess = (partnershipsControllerHardDeleteResponse204) & {
  headers: Headers;
};
;

export type partnershipsControllerHardDeleteResponse = (partnershipsControllerHardDeleteResponseSuccess)

export const getPartnershipsControllerHardDeleteUrl = (accountId: string,
    partnershipId: unknown,) => {


  

  return `/accounts/${accountId}/partnerships/${partnershipId}/hard`
}

export const partnershipsControllerHardDelete = async (accountId: string,
    partnershipId: unknown, options?: RequestInit): Promise<partnershipsControllerHardDeleteResponse> => {
  
  return customFetch<partnershipsControllerHardDeleteResponse>(getPartnershipsControllerHardDeleteUrl(accountId,partnershipId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  



export const getPartnershipsControllerHardDeleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerHardDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerHardDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext> => {

const mutationKey = ['partnershipsControllerHardDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof partnershipsControllerHardDelete>>, {accountId: string;partnershipId: unknown}> = (props) => {
          const {accountId,partnershipId} = props ?? {};

          return  partnershipsControllerHardDelete(accountId,partnershipId,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PartnershipsControllerHardDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof partnershipsControllerHardDelete>>>
    
    export type PartnershipsControllerHardDeleteMutationError = ErrorType<unknown>

    /**
 * @summary Hard delete a partnership
 */
export const usePartnershipsControllerHardDelete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof partnershipsControllerHardDelete>>, TError,{accountId: string;partnershipId: unknown}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof partnershipsControllerHardDelete>>,
        TError,
        {accountId: string;partnershipId: unknown},
        TContext
      > => {
      return useMutation(getPartnershipsControllerHardDeleteMutationOptions(options), queryClient);
    }
    